export default [
  {
    id: '9900d77f-32d1-415a-b0d2-3f589daadc3e', // id 全局唯一，终身制
    name: 'sceneConfigure',
    path: '/scene-configure',
    meta: { title: '场景配置' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '3428d530-4cce-437f-906d-db25ca8e731b',
        path: 'index',
        name: 'sceneConfigure',
        component(resolve) {
          require(['./views/index'], resolve)
        },
        meta: {
          title: '场景配置',
          operations: {},
          hidden: true,
        },
      },
    ],
  },
]
